import { CircularProgress } from '@mui/material'
import React from 'react'

export default ({message = 'Loading...'}) => (
  <div className="loading">
    <CircularProgress
      className="loading__indicator"
      size={50}
      status="loading"
      left={0}
      top={0}
    />
    <div className="loading__message">
      <h2>{message}</h2>
    </div>
  </div>
)
